export default function Tag({ text }: { text: string }) {
  const colors = ["#00eaff", "#ff00ff", "#ffae00", "#00ff85"];
  const color = colors[text.length % colors.length];

  return (
    <span
      style={{
        padding: "4px 10px",
        borderRadius: "8px",
        background: color + "33",
        border: `1px solid ${color}`,
        color,
        fontSize: "13px",
        marginRight: "6px",
      }}
    >
      {text}
    </span>
  );
}